<template>
  <v-container class="pb-10">
      <v-flex xs12 sm12>
        <v-card class="rounded-xl elevation-4">
          <v-card-title class="primary white--text">
            <v-toolbar-title class="headline font-weight-bold">
              Técnicos da Unidade
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchAtivo"
              append-icon="mdi-magnify"
              label="Buscar técnico..."
              single-line
              hide-details
              dark
              clearable
              class="pt-0"
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="listaFuncionariosAtivos"
            :search="searchAtivo"
            :page.sync="page"
            :items-per-page="10"
            no-data-text="Nenhum técnico encontrado"
            no-results-text="Nenhum resultado para a busca"
            class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <div class="d-flex justify-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      color="primary"
                      v-on="on"
                      @click="cadastrarTecnicoExame(item)"
                      class="mx-1"
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Adicionar exames</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      color="secondary"
                      v-on="on"
                      @click="cadastrarTecnicoServico(item)"
                      class="mx-1"
                    >
                      <v-icon>mdi-hospital-building</v-icon>
                    </v-btn>
                  </template>
                  <span>Adicionar serviços</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      color="warning"
                      v-on="on"
                      @click="alterarDadosTecnico(item)"
                      class="mx-1"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar técnico</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
  </v-container>
</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'listaAdministrador',
  data () {
    return {
      page: 1,
      tipo: 8,
      searchAtivo: '',
      searchDesativo: '',
      isEditing: true,
      listaFuncionariosAtivos: [],
      listaFuncionariosDesativos: [],
      administradorSelecionado: null,
      headers: [{
        text: 'Nome do Técnico',
        align: 'center',
        sortable: true,
        value: 'nome'
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false
      }
      ],
      headersDesativado: [{
        text: 'Nome do Técnico',
        align: 'center',
        sortable: true,
        value: 'nome'
      },

      {
        text: 'Ativar médico',
        align: 'center',
        value: 'name',
        sortable: false
      }

      ],
      listaFuncionarios: [],
      user: null,
      items: [{
        username: 'Elvis',
        idMedico: 1
      },
      {
        username: 'Cassio',
        idMedico: 3
      },
      {
        username: 'Leandro',
        idMedico: 2
      },
      {
        username: 'Ana',
        idMedico: 15
      },
      {
        username: 'Ricardo',
        idMedico: 14
      },
      {
        username: 'Cleison',
        idMedico: 22
      }
      ]
    }
  },
  components: {
    // HelloWorld
  },
  mounted () {
    console.log('em mounted lista medicos...')
    this.user = this.$store.getters.usuario
    // console.log(this.user);
    this.retornarFuncionarios()
  },
  methods: {

    retornarFuncionarios () {
      console.log('em retornar funcionarios medicos...')
      administradorUnidadeService.administradorUnidade
        .retornarFuncionarios(this.tipo)
        .then(rsp => {
          console.log('rsp oi:')
          this.listaFuncionarios = rsp.data
          this.listaFuncionarios.forEach(funcionario => {
            if (funcionario.ativo) {
              this.listaFuncionariosAtivos.push(funcionario)
            } else {
              this.listaFuncionariosDesativos.push(funcionario)
            }
          })
          console.log(this.listaFuncionarios)
          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    ativarMedico (item) {
      if (confirm('Deseja ativar esse Médico?')) {
        // this.items.splice(index, 1)
        const index = this.listaFuncionariosDesativos.indexOf(item)
        console.log('excluir atendet..')
        console.log(typeof (item.username))
        administradorUnidadeService.administradorUnidade.ativarFuncionario(item.username, this.tipo)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosDesativos.splice(index, 1)
              this.listaFuncionariosAtivos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    desativarMedico (item) {
      if (confirm('Deseja desativar esse Médico?')) {
        // this.items.splice(index, 1)
        const index = this.listaFuncionariosAtivos.indexOf(item)
        console.log('item.username..')
        administradorUnidadeService.administradorUnidade.desativarFuncionario(item.username, this.tipo)
          .then(rsp => {
            console.log('rsp oi:', rsp)
            if (rsp.data == true) {
              this.listaFuncionariosAtivos.splice(index, 1)
              this.listaFuncionariosDesativos.push(item)
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    importarTecnicos () {
      console.log('em retornar funcionarios atendente...')
      administradorUnidadeService.administradorUnidade
        .importarTecnicos()
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    cadastrarTecnicoExame (item) {
      console.log(' em cadastrar medico servico...')
      this.$router.push({
        name: 'cadastrarTecnicoExame',
        params: {
          item: item
        }
      })
    },
    cadastrarTecnicoServico (item) {
      console.log(' em cadastrar medico servico...')
      this.$router.push({
        name: 'cadastrarTecnicoServico',
        params: {
          item: item
        }
      })
    },
    alterarDadosTecnico (data) {
      this.$router.push({
        name: 'alterarDadosTecnico',
        params: {medico: data}
      })
    }

  },
  created () {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

.rounded-card {
  border-radius: 35px;
}

#mybutton2 {
  position: fixed;
  bottom: 30px;
  right: 20px;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
